import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import React, { useMemo } from "react";
import { IBoorHull } from "@mcapps/shared/reportSchemas/geoteknikSchema";

export const BORRING_TABLE_COLUMN: ColDef<IBoorHull>[] = [
  { field: "id", headerName: "Borrhull ID" },
  { field: "x", headerName: "X" },
  { field: "y", headerName: "Y" },
  { field: "z", headerName: "Z" },
  { field: "metode", headerName: "Metode" },
  { field: "stopp", headerName: "Stopp" },
  { field: "losm", headerName: "Løsmasse" },
  { field: "fjell", headerName: "Fjell" },
  { field: "totalt", headerName: "Totalt" },
];

const BorringTable: React.FC<{ borrhuler: IBoorHull[] }> = ({ borrhuler }) => {
  const columnDefs = useMemo<ColDef<IBoorHull>[]>(
    () =>
      BORRING_TABLE_COLUMN.map((col) => ({
        ...col,
        sortable: true,
        filter: true,
        resizable: true,
      })),
    [],
  );

  return (
    <div className="ag-theme-alpine" style={{ width: "100%", overflow: "auto" }}>
      <AgGridReact
        rowData={borrhuler || []}
        columnDefs={columnDefs}
        defaultColDef={{
          flex: 1,
          minWidth: 80,
          resizable: true,
        }}
        domLayout="autoHeight"
      />
    </div>
  );
};

export default BorringTable;
